


export class BrowserAppEvaluationToolInfo {

  public version = '2024.4.17.1';

  constructor() {
  }

}
